/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { TabPanel } from '@smartsheet/lodestar-core';
import React, { createRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  selectIsUpsertScheduleVisible,
  selectSelectedScheduleIndex,
  selectSchedules,
} from '../../../../../../services/ducks/schedulesDuck';
import { NoWorkflowSchedules } from './NoWorkflowSchedules';
import { SchedulesHome } from './SchedulesHome';
import { UpsertSchedule } from './UpsertSchedule';

const contaierStyle = css`
  display: flex;
  justify-content: center;
  overflow-y: auto;
`;

const partialContainerStyle = css`
  width: 100%;
`;

export const Schedules = () => {
  const isUpsertScheduleVisible = useSelector(selectIsUpsertScheduleVisible);
  const selectedScheduleIndex = useSelector(selectSelectedScheduleIndex);
  const schedules = useSelector(selectSchedules);
  const containerRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (containerRef.current?.scrollTo) containerRef.current?.scrollTo(0, 0);
  }, [selectedScheduleIndex, containerRef]);

  return (
    <TabPanel css={contaierStyle} ref={containerRef}>
      {!isUpsertScheduleVisible && schedules.length === 0 ? (
        <NoWorkflowSchedules />
      ) : (
        <div css={partialContainerStyle}>
          {isUpsertScheduleVisible ? (
            <UpsertSchedule scheduleIndex={selectedScheduleIndex} />
          ) : null}
          <SchedulesHome />
        </div>
      )}
    </TabPanel>
  );
};
